import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import _get from 'lodash-es/get';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConfigService } from '../config.service';
import { HTTP_OPTIONS } from '../../config/http-opts.config';
import { LoginRequest } from '../../model/login.interface';
import { QueryParams } from '../../constants/constants';

@Injectable()
export class LoginService {
  mainConfig;
  devOrStg: boolean;
  constructor(
    private readonly _http: HttpClient,
    private readonly configService: ConfigService,
  ) {
    this.mainConfig = this.configService.getConfig();
    this.devOrStg = _get(this.mainConfig, 'name') === 'staging' || _get(this.mainConfig, 'name') === 'dev';
   }

  login(body: LoginRequest, redirectUrl: string): Observable<object> {
    const encodeRedirectUrl = encodeURIComponent(redirectUrl) || '';
    let params = new HttpParams().set('redirect-url', encodeRedirectUrl);
    const url = `${_get(this.mainConfig, 'identity_url')}/login`;
    if (this.devOrStg) {
      params = params.append(QueryParams.Skip2Fa, String(true));
    }

    return this._http.post(url, body, { ...HTTP_OPTIONS, params });
  }
}
